
export const RegionQueryKey = {
    index: ['regions']
};
